//Dependencies
import { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

// Componentes
import Button from '@mui/material/Button';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MUITextFieldStyle from '../../MUIStyles/MUITextFieldStyle';
import CircularProgress from '@mui/material/CircularProgress';
import Alert from '../../Alert';
import SectionTitle from '../../SectionTitle';

// Queries
import postAtencionesAlta from '../../Queries/postAtencionesAlta';
import getGlobal from '../../Queries/getGlobal';

// Styles
import styles from './index.module.sass';
import MUISelectStyle from '../../MUIStyles/MUISelectStyle';

export default function Send(props) {
  const { t, i18n } = useTranslation('attentions');
  const { language = '' } = i18n;
  // const sections = t('sections', { returnObjects: true });

  const { setSessionMessage } = props;
  const [imagesrc, setImagesrc] = useState('');
  //const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [alertTitle, setAlertTitle] = useState('');
  const [alertText, setAlertText] = useState('');
  const [open, setOpen] = useState(false);
  const [sections, setSections] = useState([]);
  const [product, setProduct] = useState('');
  const [productsQuantity, setProductsQuantity] = useState('');
  const [productsArray, setProductsArray] = useState([]);
  const [sectionSelected, setSectionSelected] = useState({
    name: '',
    value: '',
    sectionValue: '',
    codigoRequerido: false,
    noPedidoRequerido: false,
  });

  const [form, setForm] = useState({
    afected: '',
    description: '',
    orderid: '',
  });

  function addProduct() {
    if (!product || !productsQuantity) return;
    setProductsArray((oldArray) => [
      ...oldArray,
      {
        codigoProducto: product,
        unidades: productsQuantity,
      },
    ]);
    setProduct('');
    setProductsQuantity('');
  }

  function deleteProduct(value) {
    setProductsArray((oldArray) => {
      let old = oldArray;
      var index = oldArray.findIndex((obj) => obj.codigoProducto === value.codigoProducto);
      if (index !== -1) {
        old.splice(index, 1);
      }
      return [...old];
    });
  }

  function handleProductChange(e) {
    if (e.target.value.length > 5) return;

    setProduct(e.target.value);
  }

  function handleQuantity(e) {
    setProductsQuantity(e.target.value);
  }

  function handleForm(e) {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  }

  function handleChange(e) {
    const value = e.target.value;
    setSectionSelected({
      name: language.includes('es') ? sections[value]?.atencion : sections[value]?.atencionIng,
      value: value,
      sectionValue: sections[value]?.codigo ?? '',
      codigoRequerido: sections[value]?.codigoRequerido ?? false,
      noPedidoRequerido: sections[value]?.noPedidoRequerido ?? false,
    });
  }

  async function handleSubmit(e) {
    if (
      !sectionSelected.name ||
      !form.afected ||
      !form.description ||
      (sectionSelected?.codigoRequerido && productsArray.length <= 0) ||
      (sectionSelected?.noPedidoRequerido && !form.orderid)
    ) {
      setAlertTitle(t('requiredTitle'));
      setAlertText(t('requiredText'));
      setOpen(true);
      return null;
    }

    setLoading(true);

    let imagenBase64 = '';
    if (imagesrc) {
      const imagenTmp = imagesrc.split(',');
      if (imagenTmp.length > 1) imagenBase64 = imagenTmp[1];
    }

    const response = await postAtencionesAlta({
      jsonBody: {
        comentarios: form.description,
        imagenBase64: imagenBase64,
        kitaten: form.afected,
        principal: sectionSelected?.name || '',
        principalIndex: sectionSelected.sectionValue,
        subDescri: '',
        subIndex: '',
        productos: productsArray,
        pedido: form.orderid,
      },
    });

    const { tipoMensaje = 'error', dato1 = '', mensaje = '' } = response;

    setSessionMessage(mensaje);

    if (tipoMensaje === 'exito') {
      setAlertTitle(t('successTitle'));
      setAlertText(`${t('successText1')} #${dato1}, ${t('successText2')}`);
      setOpen(true);
      setSectionSelected({
        name: language.includes('es') ? sections[0]?.atencion : sections[0]?.atencionIng,
        value: 0,
        sectionValue: sections[0]?.codigo || '',
        codigoRequerido: sections[0]?.codigoRequerido ?? false,
        noPedidoRequerido: sections[0]?.noPedidoRequerido ?? false,
      });

      setProductsArray([]);

      setForm({
        afected: '',
        description: '',
        orderid: '',
      });
    } else {
      setAlertTitle('Ooops!');
      setAlertText(mensaje ? mensaje : t('sendError'));
      setOpen(true);
    }

    setLoading(false);
  }

  const getAttentionCatalog = useCallback(async () => {
    const resp = await getGlobal({ tmbservice: 'getCatalogoAtenciones', jsonBody: {} });

    if (resp?.messageCode !== 200) {
      return;
    }

    setSections(resp?.listTipoAtenciones);

    setSectionSelected({
      name: language.includes('es')
        ? resp?.listTipoAtenciones[0]?.atencion
        : resp?.listTipoAtenciones[0]?.atencionIng,
      value: 0,
      sectionValue: resp?.listTipoAtenciones[0]?.codigo || '',
      codigoRequerido: resp?.listTipoAtenciones[0]?.codigoRequerido ?? false,
      noPedidoRequerido: resp?.listTipoAtenciones[0]?.noPedidoRequerido ?? false,
    });
  }, [language]);

  useEffect(() => {
    getAttentionCatalog();
  }, [getAttentionCatalog]);

  return (
    <div className={styles.attentions}>
      <Alert open={open} setOpen={setOpen} title={alertTitle} text={alertText} />
      <SectionTitle title={t('new')} subtitle={t('attention')} />
      <div className={styles.container}>
        <div className={styles.selectContainer}>
          <FormControl variant='outlined' style={{ width: '100%' }}>
            <InputLabel id='area-select-outlined-label'>Area de atención *</InputLabel>
            <Select
              labelId='area-select-outlined-label'
              id='area-select-outlined'
              value={sectionSelected.value}
              name='area'
              onChange={(e) => handleChange(e)}
              label={t('area')}
              input={<MUISelectStyle />}>
              {sections.map((val, key) => {
                const { atencion = '', atencionIng = '', codigo = '' } = val;
                return (
                  <MenuItem key={key} value={key}>
                    {language.includes('es') ? atencion : atencionIng} - {codigo}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </div>

        <div className={styles.inputContainer}>
          <MUITextFieldStyle
            fullWidth
            id='afected-css-outlined-kit-input'
            label={t('affectedKit')}
            type='number'
            name='afected'
            variant='outlined'
            value={form.afected}
            onChange={(e) => handleForm(e)}
          />
        </div>

        {sectionSelected?.noPedidoRequerido && (
          <div className={styles.inputContainer}>
            <MUITextFieldStyle
              fullWidth
              id='orderid-css-outlined-kit-input'
              label={t('orderid')}
              type='number'
              name='orderid'
              variant='outlined'
              value={form.orderid}
              onChange={(e) => handleForm(e)}
            />
          </div>
        )}

        {sectionSelected?.codigoRequerido && (
          <>
            <div className={styles.productsTitle}>{t('productsTitle')}</div>

            <div>
              {productsArray.length <= 0 ? (
                ''
              ) : (
                <div className={styles.productsList}>
                  {t('products')}
                  {productsArray.map((val, key) => {
                    return (
                      <div className={styles.productSpan} key={key}>
                        <strong>{val.codigoProducto}</strong>, {t('quantity')}:{' '}
                        <strong>{val.unidades}</strong>
                        <div className={styles.deleteProduct} onClick={() => deleteProduct(val)}>
                          <span className={`material-icons-outlined ${styles.deleteIcon}`}>
                            delete
                          </span>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>

            <div className={styles.inputContainer}>
              <MUITextFieldStyle
                id='productid-css-outlined-kit-input'
                label={t('productid')}
                type='number'
                name='productid'
                variant='outlined'
                value={product}
                onChange={(e) => handleProductChange(e)}
              />

              <MUITextFieldStyle
                id='quantity-css-outlined-kit-input'
                label={t('quantity')}
                type='number'
                name='quantity'
                variant='outlined'
                value={productsQuantity}
                onChange={(e) => handleQuantity(e)}
              />
              <div className={styles.addProduct} onClick={() => addProduct()}>
                <span className={`material-icons-outlined ${styles.addIcon}`}>add</span>
              </div>
            </div>
          </>
        )}

        <div className={styles.inputContainer}>
          <MUITextFieldStyle
            fullWidth
            multiline
            rows={5}
            id='description-css-outlined-kit-input'
            label={t('description')}
            type='text'
            name='description'
            variant='outlined'
            value={form.description}
            onChange={(e) => handleForm(e)}
          />
        </div>
        <div className={styles.divForm}>
          <div className={styles.imageViewport}>
            <input
              id={styles.imagefile}
              type='file'
              name='upload'
              onChange={function (e) {
                var files = e.target.files;
                var reader = new FileReader();
                reader.onload = function () {
                  setImagesrc(reader.result);
                };
                reader.readAsDataURL(files[0]);
              }}
            />
            {imagesrc ? (
              <img src={imagesrc} onError={function () {}} alt='' />
            ) : (
              <div className={styles.instructions}>
                <i className={`material-icons-outlined ${styles.icon}`}>add_a_photo</i>
              </div>
            )}
            <div className={styles.uploadImage}>
              <i className={`material-icons-outlined ${styles.iconIstructions}`}>add_a_photo</i>
              <span>{t('selectImage')}</span>
            </div>
          </div>
          <div className={styles.lastMessage}>{t('notMandatory')}</div>
        </div>
        <div className={styles.buttonContainer}>
          <Button
            type='submit'
            variant='contained'
            size='large'
            color='primary'
            className={styles.sendButton}
            onClick={(e) => handleSubmit(e)}>
            {(loading && <CircularProgress className={styles.circularProgress} />) || (
              <>
                {t('sendButton')}
                <span className={`material-icons-outlined ${styles.sendIcon}`}>trending_flat</span>
              </>
            )}
          </Button>
        </div>
      </div>
    </div>
  );
}
